module.exports = __webpack_public_path__ + "static/images/frequent-grey.1D1E9XX.svg";